import { gql } from '@apollo/client';
import { Address } from '@global/types/types';

export interface GET_SAVED_CUSTOMER_ADDRESSES_RESPONSE {
  wGetSavedAddresses: {
    data: Address[];
  };
}

export interface GET_SAVED_CUSTOMER_ADDRESSES_VARIABLES {
  customerUid: string;
  siteId: string;
  type: 'SHIPPING' | 'BILLING';
}

export const GET_SAVED_CUSTOMER_ADDRESSES = gql`
  query wGetSavedAddresses(
    $customerUid: String!
    $siteId: String!
    $type: String!
  ) {
    wGetSavedAddresses(customer: $customerUid, site: $siteId, type: $type)
  }
`;
